module.exports = __webpack_public_path__ + "officialStatic/img/logo10.fd68074.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/about/logo10.png
// module id = ktKa
// module chunks = 0